import useFormGroupValidation from './useFormGroupValidation';
import { useCallback } from 'react';

export const useFieldsetValidation = props => {
	const { getGroupProps, getLabelProps, getInputProps, getHelpblockProps, inputRef, validation } = useFormGroupValidation(props);

	const getFieldsetProps = useCallback(
		overrideProps => {
			const groupProps = getGroupProps(overrideProps);
			const { 'aria-describedby': ariaDescribedBy } = getInputProps();
			return {
				as: 'fieldset',
				'aria-describedby': ariaDescribedBy,
				...groupProps
			};
		},
		[getGroupProps, getInputProps]
	);

	const getLegendProps = useCallback(
		overrideProps => {
			const labelProps = getLabelProps(overrideProps);
			return {
				as: 'legend',
				className: validation.isInvalid ? 'is-invalid' : null,
				...labelProps
			};
		},
		[getLabelProps, validation]
	);

	return {
		getGroupProps: getFieldsetProps,
		getLabelProps: getLegendProps,
		getHelpblockProps,
		inputRef,
		validation
	};
};
